import React from "react";
import {
  ErrorBoundary,
  SearchProvider,
  WithSearch,
} from "@elastic/react-search-ui";
import "@elastic/react-search-ui-views/lib/styles/styles.css";
import AppLayout from "./layout";
import config from "./config";

export default function App() {
  return (
    <SearchProvider config={config}>
      <WithSearch
        mapContextToProps={({ wasSearched, setSearchTerm, addFilter }) => ({
          wasSearched,
          setSearchTerm,
          addFilter,
        })}
      >
        {({ setSearchTerm, addFilter }) => {
          return (
            <div className="">
              <ErrorBoundary>
                <AppLayout {...{ setSearchTerm, addFilter }} />
              </ErrorBoundary>
            </div>
          );
        }}
      </WithSearch>
    </SearchProvider>
  );
}
